/* Shard House — Experience Page scroll reveal */
(function () {
    if (window.__shExpRevealInit) return;
    window.__shExpRevealInit = true;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15 });

    function observe() {
        document.querySelectorAll('.sh-exp-reveal:not(.is-visible)').forEach(function (el) {
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observe);
    } else {
        observe();
    }
})();
